import {Component, Module} from 'app/decorators';
import UserService from 'app/services/user';
import tpl from './company-id.picker.html';


@Module({
    name: "app.directives.companyid",
    modules: [UserService],
})
@Component({
    selector: 'blnd-company-id-picker',
    bindings: {
        ngModel: '=',
        ngChange: '&',
        testId: '@?',
    },
    template: tpl,
})
export default class C {
    constructor ($timeout, UserService) {
        "ngInject";
        this.$timeout = $timeout;
        this.$user = UserService.$user;
    }

    _ngChange (newV, oldV) {
        this.$timeout(() => {
            this.ngChange(newV, oldV)
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/company-id.picker.js